<template>

    <div class="bg-gray-50">
      <div class="relative overflow-hidden">

        <div class="relative pt-6 pb-16 sm:pb-24">
            <!-- Header section -->

            <div class="bg-white">
            <div class="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
                <div class="space-y-12">
                <div class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                    <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">Demonstration Projects</h2>
                    <p class="text-xl text-gray-500">Demo projects have limited functionality, however, you may register new accounts and see how things work. <br><br> If you would like a more in depth review of a project contact us to schedule an appointment!</p>
                </div>
                <ul class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
                    <li>
                    <div class="space-y-4">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/chamber.png" alt="">
                        </div>

                        <div class="space-y-2">
                            <div class="text-lg leading-6 font-medium space-y-1">
                                <h3>Chamber of Commerce / Payment Proccessing</h3>
                                <!-- @click="singleDemo('Spring-Lake')" -->
                                <p class="text-indigo-600"><a @click="redirect('https://chamber.vqventure.com/', 'Chamber of Commerce')" target="_blank" > Learn More </a></p>
                            </div>

                        </div>
                    </div>
                    </li>

                    <li>
                    <div class="space-y-4">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/360demo.jpg" alt="">
                        </div>

                        <div class="space-y-2">
                            <div class="text-lg leading-6 font-medium space-y-1">
                                <h3>Business Scheduling / Payment Proccessing</h3>
                                <!-- @click="singleDemo('Spring-Lake')" -->
                                <p class="text-indigo-600"><a @click="redirect('https://scheduler-demo.vqventure.com/', 'Business Scheduling')" target="_blank" > Learn More</a></p>
                            </div>

                        </div>
                    </div>
                    </li>

                  <li>
                    <div class="space-y-4">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/glen.jpg" alt="">
                        </div>

                        <div class="space-y-2">
                            <div class="text-lg leading-6 font-medium space-y-1">
                                <h3>Digital Document Management / Payment Proccessing</h3>
                                <!-- @click="singleDemo('Spring-Lake')" -->
                                <p class="text-indigo-600"><a @click="redirect('https://glenn-demo.vqventure.com/', 'Digital Document Management')" target="_blank" >Learn More</a></p>
                            </div>

                        </div>
                    </div>
                    </li>

                  <li>
                    <div class="space-y-4">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/twon.jpg" alt="">
                        </div>

                        <div class="space-y-2">
                            <div class="text-lg leading-6 font-medium space-y-1">
                                <h3>Goverment - Public Relations / Document Management</h3>
                                <!-- @click="singleDemo('Spring-Lake')" -->
                                <p class="text-indigo-600"><a @click="redirect('https://spring-lake-demo.vqventure.com/', 'Goverment Software')" target="_blank" > Learn More</a></p>
                            </div>

                        </div>
                    </div>
                    </li>

                  <li>
                    <div class="space-y-4">
                        <div class="aspect-w-3 aspect-h-2">
                        <img class="object-cover shadow-2xl rounded-lg" src="https://homemanagerfortesting.s3.amazonaws.com/justin.jpg" alt="">
                        </div>

                        <div class="space-y-2">
                            <div class="text-lg leading-6 font-medium space-y-1">
                                <h3>Waste Disposal / Recurring Payment Services</h3>
                                <!-- @click="singleDemo('Spring-Lake')" -->
                                <p class="text-indigo-600"><a @click="redirect('https://scheduler-demo.vqventure.com/', 'Waste Disposal Services')" target="_blank" > Learn More </a></p>
                            </div>

                        </div>
                    </div>
                    </li>


                    <!-- More items... -->
                </ul>
                </div>
            </div>
            </div>




        </div>


      </div>

        <div v-if="!$store.state.auth">
            <div v-if="sessionItem"></div>
              <div v-else :class="{'delay': delayItem }" :style="delayItem ? 'display:flex' : 'display:none'" class="relative bg-white">
                  <contact :requestedUrl="requestedProyectUrl" :proyect="proyect" v-on:event="delayItem = false"></contact>
              </div>
        </div>


    </div>

</template>

<script>
export default {
  data() {
    return {
      delayItem: false,
      proyect: '',
      requestedProyectUrl: ''
    };
  },

  computed: {
    sessionItem(){
      return sessionStorage.getItem('modal');
    }

    },


  methods: {
    singleDemo(value){
        this.$router.push({ name: "SingleDemo", params: { id: value } })
    },
    redirect(url, value) {
      
      if(this.sessionItem) {
        window.location.href = url;
      }else {
        this.delayItem = true
        this.proyect = value
        this.requestedProyectUrl = url
      } 
      
    }
  }
};
</script>

<style scoped>

.delay {

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  
  /* this is what centers your element in the fixed wrapper*/
  display: flex;
  flex-flow: column nowrap;
  justify-content: center; /* aligns on vertical for column */
  align-items: center; /* aligns on horizontal for column */
  

  z-index: 20;
  animation-name: fadeIn;
  -webkit-animation-name: fadeIn;
  animation: 1s ease 0s normal forwards 1 fadeIn;

}

@keyframes fadeIn{
     0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
}

</style>

